import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';

export function minimumAgeValidator(minAge: number = 18): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return null;

    const birthdate = moment.utc(value, moment.ISO_8601, true).startOf('day');
    if (!birthdate.isValid()) return null;

    const today = moment.utc().startOf('day');
    const age = today.diff(birthdate, 'years');

    return age >= minAge ? null : { underage: { requiredAge: minAge, actualAge: age } };
  };
}
